module.exports = __webpack_public_path__ + "static/media/cutsglare_german_00255.8775ec81.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/de/cutsglare_german_00255.png
// module id = 1284
// module chunks = 0